var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row select-edit confirmation-page" }, [
        _vm._m(0),
        !_vm.paymentStatus
          ? _c(
              "div",
              { staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end" },
              [
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.editSlide(0)
                      },
                    },
                  },
                  [_vm._v("Edit")]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("hr", { staticClass: "cnf-hr-line" }),
      _vm._l(_vm.serviceSelected, function (service, index) {
        return _c("div", { key: index }, [
          _c("div", { staticClass: "selected-service-border" }, [
            _c("div", { staticClass: "row confirmation-page" }, [
              _c(
                "div",
                { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-12 col-md-12 col-sm-12 col-sm-12 cnf-selected",
                      },
                      [_c("p", [_vm._v(_vm._s(service.name))])]
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-12 col-md-12 col-sm-12 col-sm-12 cnf-single-service",
                      },
                      [
                        service.id !== 2 && !service.is_bundle
                          ? _c("p", [_vm._v("Base Price")])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-8 col-md-7 col-sm-7 col-xs-8 renew_label pr-0",
                      },
                      [
                        !service.is_bundle &&
                        _vm.serviceMarket !== "" &&
                        service.id === 2
                          ? _c("p", [
                              _vm._v(
                                " New expiration " +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm._f("newExpiration")(
                                        service.valid_until
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        !service.is_bundle && service.id !== 2
                          ? _c("p", [
                              _vm._v(
                                " New expiration " +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm._f("newExpiration")(
                                        service.valid_until
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        service.is_bundle
                          ? _c("p", [
                              _vm._v(
                                " New expiration " +
                                  _vm._s(
                                    _vm.displayBundleDate(service.valid_until)
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-5 col-sm-5 col-xs-4 cnf-selected text-end",
                      },
                      [
                        _vm.serviceMarket == "" && service.id === 2
                          ? _c("p", [_vm._v("Free")])
                          : _vm._e(),
                        service.id !== 2
                          ? _c("p", [
                              _c("span", [
                                _vm._v("$" + _vm._s(service.price) + " "),
                              ]),
                              service.id == 9 || service.id == 10
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cnf-single-service hidden-xs",
                                    },
                                    [_vm._v("per use")]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cnf-single-service hidden-xs",
                                    },
                                    [_vm._v("per year")]
                                  ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._m(1, true),
                ]
              ),
            ]),
            service.id !== 2
              ? _c("hr", { staticClass: "cnf-hr-line hidden-xs" })
              : _vm._e(),
            service.id === 1
              ? _c("div", [
                  _vm.selectedRecords && _vm.selectedRecords.price
                    ? _c("div", { staticClass: "row confirmation-page" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service",
                          },
                          [
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedRecords.value) +
                                  " records & " +
                                  _vm._s(
                                    _vm.selectedRecords.storage / (1024 * 1024)
                                  ) +
                                  "GB storage included "
                              ),
                              _vm.selectedRecords.price === 0
                                ? _c("span", [_vm._v("for free")])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm.selectedRecords.price != 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end",
                              },
                              [
                                _vm._v(
                                  " $" + _vm._s(_vm.selectedRecords.price) + " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "cnf-single-service hidden-xs",
                                  },
                                  [_vm._v("per year")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._m(2, true),
                ])
              : _vm._e(),
            service.id === 13 || service.id === 14
              ? _c("div", { staticClass: "row confirmation-page" }, [
                  _vm._m(3, true),
                ])
              : _vm._e(),
            service.id === 14
              ? _c("div", { staticClass: "row confirmation-page" }, [
                  _vm._m(4, true),
                ])
              : _vm._e(),
            service.id === 16
              ? _c("div", [_vm._m(5, true), _vm._m(6, true)])
              : _vm._e(),
            service.id === 15 || service.id === 13
              ? _c("div", [
                  _c("div", { staticClass: "row confirmation-page" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("span", {}, [
                        _vm._v(
                          " Markets selected under Regulatory Reports : " +
                            _vm._s(_vm.getCountriesList())
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._m(7, true),
                ])
              : _vm._e(),
            service.id === 9 || service.id === 10
              ? _c("div", [
                  _vm.selectedRecordsProdClsRat &&
                  _vm.selectedRecordsProdClsRat.price
                    ? _c("div", { staticClass: "row confirmation-page" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service",
                          },
                          [
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedRecordsProdClsRat.name) +
                                  " " +
                                  _vm._s(service.name) +
                                  " requested "
                              ),
                              _vm.selectedRecordsProdClsRat.price === 0
                                ? _c("span", [_vm._v("for free")])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm.selectedRecordsProdClsRat.price != 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end",
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm.selectedRecordsProdClsRat.price
                                    ) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "cnf-single-service hidden-xs",
                                  },
                                  [_vm._v("total")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          service.id === 2
            ? _c("div", { staticClass: "selected-service-border" }, [
                _vm.serviceCountry && !_vm.defaultCountry && service.id === 2
                  ? _c("div", { staticClass: "row confirmation-page" }, [
                      _vm._m(8, true),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-2 col-md-2 col-sm-2 col-xs-2 cnf-end",
                        },
                        [
                          _vm.serviceCountry
                            ? _c("p", [
                                _vm._v(_vm._s(_vm.serviceCountry.country_name)),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm.serviceMarket == "all"
                  ? _c("div", { staticClass: "row confirmation-page" }, [
                      _vm._m(9, true),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-2 col-md-2 col-sm-2 col-xs-2 text-end cnf-selected",
                        },
                        [
                          _c("p", [
                            _vm._v("$" + _vm._s(service.price) + " "),
                            _c(
                              "span",
                              { staticClass: "cnf-single-service hidden-xs" },
                              [_vm._v("per year")]
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._m(10, true),
              ])
            : _vm._e(),
        ])
      }),
      _vm.showBillingInfo &&
      _vm.billingDetails &&
      _vm.billingDetails.email_address &&
      _vm.paymentSelected.id != 1
        ? _c(
            "div",
            { staticClass: "row billing-info-edit confirmation-page" },
            [
              _vm._m(11),
              _c(
                "div",
                { staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end" },
                [
                  _c(
                    "p",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.editSlide(2)
                        },
                      },
                    },
                    [_vm._v("Edit")]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.showBillingInfo &&
      _vm.billingDetails &&
      _vm.billingDetails.email_address &&
      _vm.paymentSelected.id != 1
        ? _c("hr", { staticClass: "cnf-hr-line" })
        : _vm._e(),
      _vm.showBillingInfo && _vm.billingDetails && _vm.paymentSelected.id != 1
        ? _c("div", { staticClass: "row confirmation-page cnf-sm-address" }, [
            _c(
              "div",
              { staticClass: "col-lg-4 col-md-4 col-sm-10 col-xs-10" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.billingDetails.first_name) +
                    " " +
                    _vm._s(_vm.billingDetails.last_name) +
                    " "
                ),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.email_address) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.phone_number) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.address) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.city) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.state) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.country) + " "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.billingDetails.zipcode) + " "),
              ]
            ),
          ])
        : _vm._e(),
      _vm.paymentSelected.id === 1
        ? _c("div", [
            _vm.paymentStatus
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-12 col-md-12 col-sm-12 col-xs-12 success-msg",
                  },
                  [_vm._v(" Credit card payment successful! ")]
                )
              : _vm._e(),
            !_vm.paymentStatus ? _c("br") : _vm._e(),
            _c("br"),
            _c("br"),
          ])
        : _vm._e(),
      _vm.showBillingInfo
        ? _c(
            "div",
            { staticClass: "row payment-mthd-edit confirmation-page" },
            [
              _vm._m(12),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-8 col-md-8 col-sm-7 col-xs-10 cnf-credit-card cnf-end",
                  class: {
                    "col-lg-offset-1 col-md-offset-1 col-sm-offset-2 col-xs-offset-2":
                      _vm.paymentStatus,
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.paymentSelected.mode) + " "),
                  _vm.paymentSelected.id === 3
                    ? _c("span", [
                        _vm._v(
                          ": " + _vm._s(_vm.billingDetails.purchase_order)
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              !_vm.paymentStatus
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-1 col-md-1 col-sm-2 col-xs-2 cnf-end",
                    },
                    [
                      _c(
                        "p",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.editSlide(1)
                            },
                          },
                        },
                        [_vm._v("Edit")]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.showBillingInfo ? _c("hr", { staticClass: "cnf-hr-line" }) : _vm._e(),
      (_vm.serviceSelected.id === 13 || _vm.serviceSelected.id === 14) &&
      _vm.proRataData &&
      Object.keys(_vm.proRataData).length &&
      _vm.proRataData.creditPrice
        ? _c(
            "div",
            { staticClass: "row confirmation-page cnf-sm-border mb-20" },
            [
              _vm._m(13),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected text-end font-bold",
                },
                [_vm._v(" $" + _vm._s(_vm.proRataData.creditPrice) + " ")]
              ),
            ]
          )
        : _vm._e(),
      _vm.showBillingInfo
        ? _c("div", { staticClass: "row confirmation-page cnf-sm-border" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected font-bold",
              },
              [
                !_vm.paymentStatus
                  ? _c("span", [_vm._v("Total")])
                  : _c("span", [_vm._v("Amount paid")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected text-end font-bold",
              },
              [
                _c("span", { staticClass: "cnf-selected font-bold" }, [
                  _vm._v("$" + _vm._s(_vm.totalPrice)),
                ]),
                (_vm.serviceSelected.id === 13 ||
                  _vm.serviceSelected.id === 14) &&
                _vm.proRataData &&
                Object.keys(_vm.proRataData).length &&
                _vm.proRataData.creditPrice &&
                Math.sign(
                  _vm.serviceSelected.price - _vm.proRataData.creditPrice
                ) === -1
                  ? _c("div", [
                      _vm._v(
                        " (Credit $" +
                          _vm._s(
                            Math.abs(
                              _vm.serviceSelected.price -
                                _vm.proRataData.creditPrice
                            )
                          ) +
                          ". Please contact "
                      ),
                      _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
                        _vm._v("RAMSHelp@ul.com"),
                      ]),
                      _vm._v(" for support) "),
                    ])
                  : _vm._e(),
              ]
            ),
          ])
        : _vm._e(),
      _vm._m(14),
      _c("hr", { staticClass: "cnf-hr-line mb-0" }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-11 col-md-11 col-sm-11 col-xs-10" },
      [
        _c("span", { staticClass: "cnf-select-service hidden-xs" }, [
          _vm._v("Selected"),
        ]),
        _c(
          "span",
          { staticClass: "cnf-select-service hidden-lg hidden-md hidden-sm" },
          [_vm._v("Selected Services")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6 col-md-6" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confirmation-page hidden-xs" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("span", {}, [
        _vm._v("All Markets included under Regulatory Intelligence"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("span", {}, [_vm._v("All Markets included under Regulatory Reports")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row confirmation-page" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("span", {}, [
          _vm._v("All Markets included under Regulatory Reports"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confirmation-page hidden-xs" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confirmation-page hidden-xs" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10" },
      [
        _c("span", { staticClass: "cnf-select-service" }, [
          _vm._v("Complimentary country selected"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10" },
      [
        _c("span", { staticClass: "cnf-select-service" }, [
          _vm._v("All Markets"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confirmation-page hidden-xs" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-11 col-md-11 col-sm-11 col-xs-10" },
      [
        _c("span", { staticClass: "cnf-select-service" }, [
          _vm._v("Billing Info"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-3 hidden-xs" }, [
      _c("span", { staticClass: "cnf-select-service" }, [
        _vm._v("Payment Method"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected font-bold",
      },
      [_c("span", [_vm._v("Credit Amount")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row confirmation-page pt-40 note-text" }, [
      _c("div", { staticClass: "col-xs-12 col-md-12 col-sm-12 col-lg-12" }, [
        _c("b", [_vm._v("Note:")]),
        _vm._v(
          " UL’s accounting system will automatically send an invoice to reflect your purchase in the next 7-10 days. Please disregard the balance due amount if you paid by credit card. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }